import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import { App } from "./App";
import { AuthProvider } from "./auth";
import { RealtimeProvider } from "./realtime";
import { configureAuthAnalytics } from "./analytics";

// Apply a saved preference before React paints to avoid a dark/light flash.
try {
  const savedTheme = window.localStorage.getItem("loadsub:colour-theme");
  if (savedTheme !== "dark") {
    document.documentElement.dataset.theme = "soft";
    document.documentElement.style.colorScheme = "light";
  }
} catch { /* Storage can be unavailable in hardened/private browser modes. */ }

void configureAuthAnalytics();

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  let reloadingForUpdate = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloadingForUpdate) return;
    reloadingForUpdate = true;
    window.location.reload();
  });
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js").then((registration) => registration.update());
  });
}

const publicWebUrl = (import.meta.env.VITE_PUBLIC_WEB_URL as string | undefined)?.replace(/\/$/, "");
if (publicWebUrl && window.location.origin !== publicWebUrl) {
  window.location.replace(`${publicWebUrl}${window.location.pathname}${window.location.search}${window.location.hash}`);
} else {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <RealtimeProvider><App /></RealtimeProvider>
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}
